import ModelBuilder from 'helpers/ModelBuilder';
import { EntityBase, EntityLike } from './EntityBase';
import { PaymentMethodPayload } from 'services/payloads/PaymentMethodPayload';
import { Guest } from './Guest';
import dayjs from 'dayjs';

export class PaymentMethod extends EntityBase {
  cardNumber: string;
  expiry: string;
  cvc: string;
  useMailingAsBilling: boolean;

  static Model: typeof ModelDefinition;

  static new(object: EntityLike<PaymentMethod>) {
    return super.fill(this, object);
  }
}

let fields = ModelBuilder.buildFormFields<PaymentMethod>({
  cardNumber: { label: 'Card Number' },
  expiry: { label: 'Expiry Date', placeholder: 'MM/YY' },
  cvc: { label: 'CVC' },
  useMailingAsBilling: { label: 'Use Mailing Address as Billing Address', type: 'checkbox' },
});

fields = ModelBuilder.setRulesToFields(fields, {
  expiry: [{ validator: (_, value) => expiryDateValidator(value) }],
})

const expiryDateValidator = (value: string) => {
  if (value && value.length >= 5) {
    const [mm, yy] = value.split('/');
    const expiryDate = Date.parse(`20${yy}-${mm}-01`);
    const isValid = dayjs(expiryDate) >= dayjs().startOf('month');
    if (!isValid) {
      return Promise.reject(new Error('Invalid date'));
    }
  }
  return Promise.resolve();
}

const buildPayload = (model: PaymentMethod, guest: Guest) => {
  const payload = PaymentMethodPayload.new(model);
  payload.guestId = guest.id;
  payload.cardholderName = guest.displayName;
  payload.cardVerification = model.cvc;
  payload.primary = true;
  payload.address = guest.address;
  payload.address2 = guest.address2;
  payload.city = guest.city;
  payload.country = guest.country;
  payload.postalCode = guest.postalCode;
  payload.state = guest.state;
  if (!guest.useMailingAsBilling) {
    payload.address = guest.billingAddress;
    payload.address2 = guest.billingAddress2;
    payload.city = guest.billingCity;
    payload.country = guest.billingCountry;
    payload.postalCode = guest.billingPostalCode;
    payload.state = guest.billingState;
  }

  return payload;
}

class ModelDefinition {
  static fields = fields;
  static buildPayload = buildPayload;
}
PaymentMethod.Model = ModelDefinition;
